module.exports = __webpack_public_path__ + "img/img_app.043415d1.jpg";